var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getConfig } from "@jti/fe-common";
import { getIsEvo, sanitizeBaseUrl } from "../../utils";
import { LoyaltyApiEvo } from "./LoyaltyApiEvo";
import { LoyaltyApiLegacy } from "./LoyaltyApiLegacy";
export class LoyaltyApi {
    static init() {
        const _a = getConfig(), { LOYALTY_URL, LOYALTY_TOKEN } = _a, config = __rest(_a, ["LOYALTY_URL", "LOYALTY_TOKEN"]);
        if (getIsEvo(LOYALTY_URL)) {
            return new LoyaltyApiEvo(sanitizeBaseUrl(LOYALTY_URL), LOYALTY_TOKEN, config["X-RECAPTCHA-ID"]);
        }
        return new LoyaltyApiLegacy(LOYALTY_URL, LOYALTY_TOKEN);
    }
}
//# sourceMappingURL=LoyaltyApi.js.map